<script>
import { mapGetters } from 'vuex';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Auth from 'dashboard/api/auth';

export default {
  components: { NextButton },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      getAccount: 'accounts/getAccount',
    }),
    // Org-level policy: the account decides whether members must have MFA
    // (settings.mfa_required, toggled in Account Settings). Mirrors the API
    // gate in Api::V1::Accounts::BaseController. Platform staff (SuperAdmin)
    // is exempt, matching the backend.
    accountRequiresMfa() {
      const account = this.getAccount(this.$route.params.accountId) || {};
      return Boolean(account.settings?.mfa_required);
    },
    memberNeedsMfaSetup() {
      return (
        this.accountRequiresMfa &&
        !this.currentUser.mfa_enabled &&
        this.currentUser.type !== 'SuperAdmin'
      );
    },
    // Step aside on the MFA setup screen so the member can actually enable it.
    isOnMfaSetup() {
      return this.$route.name === 'profile_settings_mfa';
    },
    shouldBlock() {
      return this.memberNeedsMfaSetup && !this.isOnMfaSetup;
    },
  },
  methods: {
    goToMfaSettings() {
      this.$router.push({
        name: 'profile_settings_mfa',
        params: { accountId: this.$route.params.accountId },
      });
    },
    logout() {
      Auth.logout();
    },
  },
};
</script>

<template>
  <div
    v-if="shouldBlock"
    class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-n-alpha-3 backdrop-blur-sm"
  >
    <div
      class="flex flex-col items-center max-w-md gap-4 p-8 text-center border rounded-xl bg-n-solid-1 border-n-weak shadow-lg"
    >
      <span
        class="flex items-center justify-center w-14 h-14 rounded-full bg-n-amber-3 text-n-amber-11 i-lucide-shield-alert text-2xl"
      />
      <h2 class="text-lg font-medium text-n-slate-12">
        {{ $t('APP_GLOBAL.MFA_REQUIRED_BANNER.TITLE') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ $t('APP_GLOBAL.MFA_REQUIRED_BANNER.MESSAGE') }}
      </p>
      <div class="flex flex-col w-full gap-2 mt-2">
        <NextButton
          :label="$t('APP_GLOBAL.MFA_REQUIRED_BANNER.ACTION')"
          color="amber"
          icon="i-lucide-shield"
          @click="goToMfaSettings"
        />
        <NextButton
          :label="$t('APP_GLOBAL.MFA_REQUIRED_BANNER.LOGOUT')"
          variant="ghost"
          color="slate"
          @click="logout"
        />
      </div>
    </div>
  </div>
</template>
